// Copyright (C) 2012 Minted Inc.  // All Rights Reserved

M.View = M.View || {};

// Note: To provide an easy way for pages to opt out of this without having to
// wait until this class name is valid, it will look for the variable
// M.View.DISABLE_EMAIL_DIALOG, and if true, it won't show.

// These are placeholders until the final lightbox designs are complete.
lightbox_templates = {
  'standard': {
    html: '' +
      '<div class="emailDialogContent">' +
      '  <input type="text" name="email" value="email"' +
      '    class="emailDialogEmail" />' +
      '  <a class="submitButton button primary h30"><span>Submit</span></a>' +
      '</div>',
    background: 'https://cdn3.minted.com/files/content/landing/lightbox-main.jpg'
  },
  'wedding': {
    html: '' +
      '<div class="emailDialogContent">' +
      '  <input type="text" name="email" value="email"' +
      '    class="emailDialogEmail" />' +
      '  <a class="submitButton button primary h30"><span>Wedding</span></a>' +
      '</div>',
    background: 'https://cdn3.minted.com/files/content/landing/lightbox-main.jpg'
  },
  'baby_and_kids': {
    html: '' +
      '<div class="emailDialogContent">' +
      '  <input type="text" name="email" value="email"' +
      '    class="emailDialogEmail" />' +
      '  <a class="submitButton button primary h30"><span>Baby</span></a>' +
      '</div>',
    background: 'https://cdn3.minted.com/files/content/landing/lightbox-main.jpg'
  }
};

/**
 * @class EmailDialog
 */
M.View.EmailDialog = Backbone.View.extend({
  gaEventTarget: 'emailLightbox',
  gaEventActionInitial: 'lightbox_triggered',
  gaEventActionSignedUp: 'lightbox_signedup',
  className: 'emailDialogLightbox',

  initialize: function() {
    _.bindAll(this, 'render');
    this.$el = $(this.el);
    this.isDialogCreated = false;
    this.cookieNamePageCounter = 'emailDialogPageCount';
    this.cookieNameCooldown = 'emailDialogCooldown';
    this.path = document.location.pathname.slice(1).split('/');
    this.queryParameters = M.Url.parseCurrentQuery();
    this.whitelistedLandingPages = ['home', 'category', 'product'];
    this.whitelistedPaths = ['wedding-planning', 'minted-coupon-codes'];
    this.blacklistedPaths = ['sem', 'el'];

    this.emailInputKeyDown = _.once(this.emailInputKeyDown);
  },

  events: {
    'click .submitButton': 'submitButtonClicked',
    'click .emailDialogEmail': 'emailInputClicked',
    'keydown .emailDialogEmail': 'emailInputKeyDown'
  },

  autoCloseDialog: function() {
    var self = this;
    $('.ui-widget-overlay').bind('click', function(){
      self.cancelButtonClicked();
      M.sendTrackAPI({
        'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
        'event': M.GA.TRACK_EVENT_ACTION.CLOSE,
        'method': 'off_box_click'
      });
    });
  },

  render: function() {
    var self = this;
    if (!self.isDialogCreated) {
      lightbox_type = self.getLightboxType();
      self.isDialogCreated = true;
      self.$el.empty();
      var html = lightbox_templates[lightbox_type].html;
      self.$el.append(html);
      self.$el.dialog({
        title: '',
        autoOpen: false,
        resizable: false,
        draggable: false,
        dialogClass: 'emailDialogLightbox',
        height: 266,
        width: 408,
        modal: true,
        minHeight: 0,
        open: function() {self.autoCloseDialog();}
      });
    }
    // Set background.
    var uiDialog = $('.emailDialogContent').parentsUntil('.ui-dialog').parent();
    // TODO: Remove hard-coded url.
    var background = lightbox_templates[lightbox_type].background;
    uiDialog.css({
      'background': "url('"+ background +"')"
    });
    // Background is too dark for normal 'X'.
    // TODO: move CSS styles to class.
    uiDialog.find('.ui-icon').html('X').css({
      'color': 'white',
      'display': 'block',
      'text-indent': '0'
    });
    uiDialog.find('.ui-dialog-titlebar-close').css({
      'background-image': 'none'
    });

    $('.ui-dialog-titlebar-close').click(function() {
      // This element encloses '.ui-icon'. IE cannot detect clicks through this
      // element to '.ui-icon', so also adding click handler here.
      self.cancelButtonClicked();
      M.sendTrackAPI({
        'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
        'event': M.GA.TRACK_EVENT_ACTION.CLOSE,
        'method': 'x_click'
      });
    });

    //TODO: base.html to get cdn.
    //TODO: base.mako has img_src.
    self.showDialog();
    $('.emailDialogEmail').blur();


    $('.emailDialogLightbox').height(250);
    $('.emailDialogLightbox').css('z-index', 2003);

    // Instrumentation
    gaTrackEventWrapper(self.gaEventTarget, self.gaEventActionInitial);
    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
      'event': M.GA.TRACK_EVENT_ACTION.TRIGGER
    });
  },

  showDialog: function() {
    this.$el.dialog('open');
  },

  // Actually use the same dialog
  showConfirmationDialog: function(promoCode, expiration_date) {
    var self = this;
    self.$el.dialog('open');
    M.Flag.setFlag(M.Flag.EMAIL_DIALOG_SIGNED_UP, true);
    var uiDialog = $('.emailDialogContent').parentsUntil('.ui-dialog').parent();
    var background = 'https://cdn3.minted.com/files/content/landing/lightbox-confirm-background.jpg';

    var $emailDialogContent = $('.emailDialogContent');
    if (promoCode) {
      $emailDialogContent.html('<p>Use Code: <b style="color:yellow">' + promoCode + '</b>' +
        ' to receive FREE SHIPPING on your first purchase. One time use only, expires on ' +
        expiration_date + '</p>');
    } else {
      $emailDialogContent.html('<p>Your free shipping offer has expired.</p>');
    }

    $emailDialogContent.css({
      'margin-top': '120px',
      'font-size' : '14pt',
      'text-align' : 'center',
      'color' : '#ffffff'
    });
    uiDialog.css({
      'background': "url('"+ background +"')"
    });
    gaTrackEventWrapper(self.gaEventTarget, self.gaEventActionSignedUp);
  },

  renderIfNotLoggedIn: function() {
    var self = this;
    // TODO: Replace == with === once we fix underlying issue that some pages assign
    // M.currentUser.uid to a string, and some to a number
    if (M.currentUser && M.currentUser.uid == 0) {
      self.renderIfAppropriate();
      return;
    }

    if (M.loggedInUser &&
      M.loggedInUser.get('userId') &&
      // TODO: Replace == with === once we fix underlying issue that some pages assign
      // M.currentUser.uid to a string, and some to a number
      M.loggedInUser.get('userId') == 0) {
      self.renderIfAppropriate();
      return;
    }

    if (!M.logInUser) {
      M.loggedInUser = new M.Model.Base.LoggedInUser();
    }

    if(!M.loggedInUser.get('userId')) {
      M.loggedInUser.bind('change:userId', function(){
        // Check user id again, in case user id changes back to 0
        // TODO: Replace == with === once we fix underlying issue that some pages assign
        // M.currentUser.uid to a string, and some to a number
        if (M.loggedInUser.get('userId') == 0) {
          self.renderIfAppropriate();
        }
      });
    }
  },

  renderIfAppropriate: function() {
    var self = this;
    // Update page counter.
    if(!M.BABY_GATE_ENABLED){
      self.incrementPageCounter();
    }

    //trigger logic for the old baby gate
    var conditions = {};
    conditions['onFirstPageView'] = self.getPageCounter() < 2;
    conditions['isSignedUp'] = M.Flag.getFlag(M.Flag.EMAIL_DIALOG_SIGNED_UP);
    conditions['babyGateEnabled'] = M.BABY_GATE_ENABLED;
    conditions['isCooldown'] = self.isCooldownActive();
    conditions['isDisabled'] = (M.View.DISABLE_EMAIL_DIALOG === true);
    conditions['isSEMUser'] = (M.matchVisitor({medium: 'sem'}) || M.matchVisitor({medium: 'cpc'}) || M.matchVisitor({medium: 'ppc'}));
    conditions['isDisplayAdvertisingUser'] = M.matchVisitor({medium: 'display'});
    conditions['notEnabledForThisBrowser'] = !self.isEnabledForThisBrowser();
    conditions['isOnMarketingUpsellPage'] = self.isOnMarketingUpsellPage();
    conditions['notOnWhitelistedPage'] = !self.isOnWhitelistedPage();
    conditions['isOnBlacklistedPath'] = self.isOnBlacklistedPath();

    // Check whitelist, blacklist, page counter, cooldown flag, disable variable,
    // SEM cookie and DisplayAdvertising cookie, and marketing upsell page.
    // Only render when conditions are appropriate.
    if (_.any(conditions)) {
      return false;
    }

    setTimeout(function() {
      self.render();
    }, 3000);

    return true;
  },

  getPageCounter: function() {
    var self = this;
    var pageCount = parseInt($.cookie(self.cookieNamePageCounter));
    if (isNaN(pageCount)) {
      pageCount = 0;
    }
    return pageCount;
  },

  incrementPageCounter: function() {
    var self = this;
    var pageCount = self.getPageCounter();
    pageCount = pageCount + 1;
    $.cookie(self.cookieNamePageCounter, pageCount, {
      expires: 1,
      path: '/'
    });
  },

  /**
   * 10-day cooldown if user closes the dialog.
   */
  startCooldown: function() {
    var self = this;
    $.cookie(self.cookieNameCooldown, true, {
      expires: 10,
      path: '/'
    });
  },

  isCooldownActive: function() {
    var self = this;
    var cookieVal = $.cookie(self.cookieNameCooldown);
    return (cookieVal !== null && cookieVal !== undefined);
  },

  /**
   * Show or not, based on browser type.
   * Currently blacklisting all mobile devices.
   */
  isEnabledForThisBrowser: function() {
    var isBlacklistedBrowser = DetectMobileQuick();
    var isMogoTest = (M.visitorHost === M.MOGOTEST_IP);
    return !isBlacklistedBrowser && !isMogoTest;
  },

  isOnKittenPage: function() {
    return this.queryParameters['it_category'] !== undefined;
  },

  isOnWhitelistedLandingPage: function() {
    return _.contains(this.whitelistedLandingPages, M.landingPageName);
  },

  isOnPath: function(paths) {
    var self = this;
    return _.any(paths, function(path) {
      path = path.split('/');
      for (var i = 0; i < path.length; i++) {
        if (path[i] !== self.path[i]) {
          return false;
        }
      }
      return true;
    });
  },

  isOnWhitelistedPath: function() {
    return this.isOnPath(this.whitelistedPaths);
  },

  isOnWhitelistedPage: function() {
    return (this.isOnKittenPage() ||
            this.isOnWhitelistedLandingPage() ||
            this.isOnWhitelistedPath());
  },

  isOnBlacklistedPath: function() {
    return this.isOnPath(this.blacklistedPaths);
  },

  // Dialog should not show when query parameter '?lb=off' is present (EC-23)
  isOnMarketingUpsellPage: function() {
    return this.queryParameters['lb'] === 'off';
  },

  submitButtonClicked: function() {
    var self = this;
    var blockUI = new BlockUIView({
      message: '<span><img alt="spinner" ' +
        'src="/static/images/spinner_20.gif" /><p>signing up</p></span>'
    });
    blockUI.render();
    $.ajax({
      url: '/dialog/email',
      type: 'POST',
      data: {
        email: $('.emailDialogEmail').val(),
        extra_context: 'email_lightbox_b',
      },
      success: function(data, success, jqXHR) {
        blockUI.remove();
        if (data.error_message) {
          alert(data.error_message);
          M.sendTrackAPI({
            'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
            'event': M.GA.TRACK_EVENT_ACTION.SUBMIT_CLICK,
            'outcome': 'error'
          });
        } else {
          self.showConfirmationDialog(data.promo_code, data.expiration_date);
          M.sendTrackAPI({
            'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
            'event': M.GA.TRACK_EVENT_ACTION.SUBMIT_CLICK,
            'outcome': 'success'
          });
        }
      },
      error: function() {
        blockUI.remove();
        alert('Sorry, something is temporarily wrong with our email signup.' +
          ' Please try again later!');
        M.sendTrackAPI({
          'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
          'event': M.GA.TRACK_EVENT_ACTION.SUBMIT_CLICK,
          'outcome': 'error'
        });
      }
    });
  },

  cancelButtonClicked: function() {
    var self = this;
    self.$el.dialog('close');
    self.startCooldown();
  },

  emailInputClicked: function() {
    var email = $('.emailDialogEmail');
    if (email.val() === 'email') {
      email.val('').css('color', 'black');
    }
  },

  /*
    'Onced' in constructor so that it only runs when the user first types
  */
  emailInputKeyDown: function() {
    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.EMAIL_LIGHTBOX,
      'event': M.GA.TRACK_EVENT_ACTION.EMAIL_INPUT_KEYDOWN,
    });
  },

  /*
    Return type of lightbox to show on current page.
    Page can either be Wedding, Baby and Kids, or Standard.
    M.lightboxType is set in ProductDetailsForm.tpl.php
  */
  getLightboxType: function() {
    if (M.lightboxType === undefined || lightbox_templates[M.lightboxType] === undefined) {
      return 'standard';
    }
    return M.lightboxType;
  }

});
